/* MUTTERSTIMME™ · SAT Akademie · Interaktives Deck
 * Quelle: Originalfolien Nenad Vladović · Korrekturen integriert
 * Stand: 5 Folien · weitere folgen */
export const mutterstimmeSlides = [
  // ── 1 · COVER ──────────────────────────────────────────────────────────
  {
    num: 1,
    type: "cover",
    title: "MUTTERSTIMME™",
    subtitle:
      "In der Kraft der Selbstfürsorge zur Mutterschaft in Balance und Selbstvertrauen.",
    intro:
      "Mutter sein ist eine der tiefsten und bedeutendsten Aufgaben im Leben. Nur wenn du gut für dich sorgst, kannst du wirklich für deine Kinder da sein. MUTTERSTIMME™ begleitet dich auf deiner Reise zu einer erfüllten, selbstbestimmten und liebevollen Mutterschaft — in Balance mit dir selbst.",
    pillars: [
      { h: "SELBSTFÜRSORGE", t: "Du bist wichtig. Dein Wohlbefinden ist die Basis für alles." },
      { h: "VERBUNDENHEIT", t: "Eine tiefe Verbindung zu dir selbst schenkt dir eine tiefe Verbindung zu deinen Kindern." },
      { h: "BALANCE", t: "Finde deine innere Mitte zwischen Familie, Alltag und dir." },
      { h: "ENTFALTUNG", t: "Entdecke deine Stärken, lebe deine Träume und sei ein Vorbild für deine Kinder." },
      { h: "VERTRAUEN", t: "Vertraue dir. Vertraue dem Leben. Du bist genau richtig." },
    ],
    tagline: "EINE STARKE MUTTER · EINE STARKE FAMILIE · EINE STARKE ZUKUNFT",
    closing: "Du bist die erste Liebe deines Kindes. Sei auch die erste Liebe deines Lebens.",
    side: {
      title: "MUTTERSTIMME™ steht für",
      items: [
        "Liebe, die bewusst beginnt — bei dir.",
        "Selbstwert, der deine Kinder stärkt.",
        "Balance, die euch alle trägt.",
        "Vertrauen, das eure Zukunft gestaltet.",
        "Ein Erbe der Liebe, das weiterlebt.",
      ],
    },
  },

  // ── 2 · WARUM MUTTERSTIMME? ────────────────────────────────────────────
  {
    num: 2,
    type: "content",
    layout: "grid",
    kicker: "WARUM MUTTERSTIMME™?",
    title: "Weil du alles gibst — und selbst nicht vergessen darfst.",
    subtitle:
      "Mutterschaft ist wundervoll — und herausfordernd. Zwischen Familie, Alltag und Verantwortung bleibt oft wenig Raum für dich selbst.",
    intro:
      "MUTTERSTIMME™ erinnert dich daran: Selbstfürsorge ist kein Luxus. Sie ist die Grundlage für alles, was du gibst.",
    bullets: [
      { h: "Erschöpfung", t: "Du gibst so viel, dass dir am Ende die Energie fehlt." },
      { h: "Selbstzweifel", t: "Du fragst dich, ob du alles richtig machst und ob du genug bist." },
      { h: "Überforderung", t: "Zu viele Aufgaben, zu viele Rollen, zu wenig Zeit." },
      { h: "Schuldgefühle", t: "Egal, was du tust — es fühlt sich nie ganz genug an." },
      { h: "Selbstverlust", t: "Du verlierst dich selbst zwischen Bedürfnissen anderer." },
    ],
    mantra: "Wenn es dir gut geht, geht es deiner Familie gut.",
    side: {
      title: "Was MUTTERSTIMME™ dir gibt",
      items: [
        "Mehr Verbindung zu dir selbst.",
        "Innere Balance im Familienalltag.",
        "Selbstvertrauen in deiner Rolle als Mutter.",
        "Praktische Werkzeuge für mehr Leichtigkeit.",
        "Raum für dich — ohne schlechtes Gewissen.",
      ],
    },
    cta: {
      title: "Du musst nicht perfekt sein",
      sub: "Um eine wunderbare Mutter zu sein. Es beginnt damit, dass du gut zu dir selbst bist.",
    },
    badge: {
      title: "MUTTERSTIMME™ ist für dich",
      lines: [
        "Für die Frau, die liebt. Die gibt. Die hält.",
        "Für die Frau, die wachsen möchte.",
        "Für die Frau, die bereit ist, sich selbst genauso wichtig zu nehmen.",
        "Für dich. Für deine Kinder. Für die Zukunft.",
      ],
    },
  },

  // ── 3 · DIE ROLLE DER MUTTER ───────────────────────────────────────────
  {
    num: 3,
    type: "content",
    layout: "grid",
    kicker: "DIE ROLLE DER MUTTER™",
    title: "Mutter sein ist eine Entscheidung — jeden Tag neu.",
    subtitle:
      "Du bist die erste Liebe, die erste Lehrerin, die erste Heldin. Du hältst Räume. Du stärkst Herzen. Du prägst Zukunft.",
    intro:
      "Eine Mutter verändert nicht nur das Leben ihrer Kinder — sie verändert die Welt.",
    bullets: [
      { h: "Liebe", t: "Bedingungslos annehmen. Mit Herz führen. Liebe geben, ohne sich selbst zu verlieren." },
      { h: "Selbstfürsorge", t: "Du kannst nur geben, was du in dir nährst. Für dich sorgen ist kein Egoismus, sondern Verantwortung." },
      { h: "Verbundenheit", t: "Eine starke Verbindung zu dir selbst und zu deinen Kindern ist das Fundament von allem." },
      { h: "Führung", t: "Du setzt den Rahmen, zeigst den Weg und hältst liebevoll Grenzen." },
      { h: "Vorbild", t: "Dein Selbstwert, deine Haltung und deine Entscheidungen prägen ihre Zukunft." },
    ],
    mantra:
      "Deine Kinder brauchen keine perfekte Mutter. Sie brauchen eine echte, liebevolle und bei sich selbst ankommende Mutter.",
    side: {
      title: "Du bist mehr als genug",
      items: [
        "Du musst nicht alles können.",
        "Du darfst Hilfe annehmen.",
        "Du darfst Pausen machen.",
        "Du darfst Fehler machen.",
        "Du darfst du selbst sein.",
      ],
    },
    cta: {
      title: "Deine Stärke ist dein Geschenk",
      sub: "Deine Heilung ist ihr Erbe.",
    },
    badge: {
      title: "MUTTERSTIMME™ erinnert dich daran",
      lines: [
        "Du bist wichtig. Du bist wertvoll. Du bist die Veränderung.",
        "Für dich. Für deine Kinder. Für die Welt.",
      ],
    },
  },

  // ── 4 · DIE HÄUFIGSTEN HERAUSFORDERUNGEN ───────────────────────────────
  {
    num: 4,
    type: "content",
    layout: "grid",
    kicker: "DIE HÄUFIGSTEN HERAUSFORDERUNGEN VON MÜTTERN",
    title: "Muttersein ist wunderschön — und oft auch anstrengend.",
    subtitle:
      "Viele Mütter geben jeden Tag ihr Bestes — und fühlen sich trotzdem erschöpft, überfordert oder nicht gut genug. Du bist nicht allein.",
    intro: "Das sind die Themen, mit denen die meisten Mütter kämpfen:",
    bullets: [
      { h: "Erschöpfung", t: "Dauernde Müdigkeit und kaum Zeit für dich selbst. Der Akku ist leer." },
      { h: "Mentale Last", t: "Denken an alles, organisieren, planen, funktionieren — rund um die Uhr." },
      { h: "Balance finden", t: "Beruf, Kinder, Haushalt, Beziehung, Freunde — und wo bleibst du dabei?" },
      { h: "Schuldgefühle", t: "Egal, was du tust — es fühlt sich oft nicht richtig genug an." },
      { h: "Selbstverlust", t: "Eigene Bedürfnisse, Träume und Identität geraten in den Hintergrund." },
      { h: "Emotionale Belastung", t: "Wut, Traurigkeit, Überforderung — und kaum Raum, diese zu fühlen." },
    ],
    mantra: "Du musst das nicht alles allein schaffen. Du darfst Unterstützung annehmen.",
    side: {
      title: "Du darfst — und du kannst",
      items: [
        "Du darfst dir Hilfe holen.",
        "Du darfst Pausen machen.",
        "Du darfst Grenzen setzen.",
        "Du darfst du selbst bleiben.",
        "Du darfst glücklich sein.",
        "Du darfst ein Leben in Balance führen.",
      ],
    },
    cta: {
      title: "Herausforderungen sind keine Schwäche",
      sub: "Sie sind ein Zeichen dafür, dass du Wichtiges leistest.",
    },
  },

  // ── 5 · DER SAT ANSATZ ─────────────────────────────────────────────────
  {
    num: 5,
    type: "content",
    layout: "grid",
    kicker: "DER SAT ANSATZ™",
    title: "Transformation beginnt bei dir.",
    subtitle:
      "Der SAT Ansatz begleitet dich auf deiner Reise zu einer erfüllten Mutterschaft — in Balance mit dir selbst und im Einklang mit deinen Kindern.",
    intro:
      "Selbstfürsorge · Achtsamkeit · Transformation. Für dich. Für deine Kinder. Für die Welt.",
    bullets: [
      { h: "Selbstfürsorge", t: "Du kümmerst dich um dich — körperlich, mental, emotional und spirituell." },
      { h: "Achtsamkeit", t: "Du bist präsent. Du hörst dir selbst zu und handelst bewusst — statt im Autopilot." },
      { h: "Innere Heilung", t: "Du löst alte Muster. Du vergibst. Du öffnest dein Herz für Neues." },
      { h: "Bewusste Mutterschaft", t: "Du verbindest dich tief mit deinen Kindern. Du begleitest sie mit Liebe, Respekt und Klarheit." },
      { h: "Verantwortung für die Welt", t: "Du lebst deine Werte. Du prägst die nächste Generation. Du bist Teil einer Bewegung." },
    ],
    mantra:
      "Wenn es dir gut geht, geht es deiner Familie gut. Wenn Familien in Balance sind, heilt die Welt.",
    side: {
      title: "Was der SAT Ansatz dir bringt",
      items: [
        "Mehr innere Ruhe und Gelassenheit.",
        "Stärkere Verbindung zu deinen Kindern.",
        "Mehr Energie und Lebensfreude.",
        "Gesunde Grenzen ohne Schuldgefühle.",
        "Klarheit über deine Werte und Ziele.",
        "Ein erfülltes Leben — in deiner Balance.",
      ],
    },
    cta: {
      title: "Du bist der Schlüssel für Veränderung",
      sub: "Wenn du dich veränderst, verändert sich alles.",
    },
    badge: {
      title: "Der SAT Ansatz ist",
      lines: [
        "Ganzheitlich — Körper, Geist und Herz.",
        "Wissenschaftlich fundiert und praxiserprobt.",
        "Spirituell — mit Sinn und höheren Werten.",
        "Individuell — angepasst an dein Leben.",
        "Nachhaltig — für dich und kommende Generationen.",
      ],
    },
  },
  // ── 6 · UNSERE ANGEBOTE ────────────────────────────────────────────────
  {
    num: 6,
    type: "content",
    layout: "grid",
    kicker: "UNSERE ANGEBOTE™",
    title: "Für Mütter. Für Familien. Für eine bessere Zukunft.",
    subtitle:
      "Wir begleiten dich mit Herz, Wissen und Erfahrung auf deinem Weg zu mehr Selbstfürsorge, innerer Balance und einer erfüllten Mutterschaft.",
    intro: "Wähle, was dich heute unterstützt — und gemeinsam wachsen wir.",
    bullets: [
      { h: "Persönliche Coachings", t: "Einzelsitzungen, die genau auf dich und deine Themen als Mutter abgestimmt sind." },
      { h: "Gruppen-Programme", t: "Austausch, Unterstützung und Inspiration in kleinen Gruppen — gemeinsam statt allein." },
      { h: "Workshops & Seminare", t: "Wissen, Impulse und praktische Werkzeuge für deinen Alltag als Mutter." },
      { h: "Online-Kurse & Webinare", t: "Flexibel lernen, wann und wo es für dich und deine Familie passt." },
      { h: "Retreats & Auszeiten", t: "Raus aus dem Alltag, rein in die Verbindung mit dir selbst und anderen Müttern." },
      { h: "Ressourcen & Tools", t: "E-Books, Meditationen, Vorlagen und mehr — für deine tägliche Unterstützung." },
    ],
    mantra: "Du musst nicht alles allein schaffen. Du brauchst nur den ersten Schritt — wir gehen ihn gemeinsam.",
    side: {
      title: "Die SAT Community",
      items: [
        "Ein geschützter Raum für Mütter.",
        "Echter Austausch auf Augenhöhe.",
        "Verständnis, das tief berührt.",
        "Freundschaften, die tragen.",
        "Gemeinsam wachsen und heilen.",
      ],
    },
    cta: {
      title: "Für jeden Schritt auf deinem Weg",
      sub: "Wir sind für dich da.",
    },
    badge: {
      title: "Flexibel · Herzlich · Persönlich",
      lines: [
        "Für jede Mutter — in jeder Lebensphase.",
        "Online oder vor Ort.",
        "Individuell wählbar und kombinierbar.",
        "Mit Herz, Professionalität und Erfahrung.",
      ],
    },
  },

  // ── 7 · UNSERE METHODEN ────────────────────────────────────────────────
  {
    num: 7,
    type: "content",
    layout: "grid",
    kicker: "UNSERE METHODEN™",
    title: "Ganzheitlich · Praxisnah · Herzgeführt.",
    subtitle:
      "Unsere Methoden verbinden fundiertes Wissen mit echter Herzensarbeit. Für nachhaltige Veränderung — in dir und für deine Familie.",
    intro: "Wir arbeiten mit Kopf, Herz und Körper — für Transformation, die bleibt.",
    bullets: [
      { h: "Herzbasierte Begleitung", t: "Mit Empathie, Präsenz und echtem Interesse begleiten wir dich auf deiner Reise." },
      { h: "Wissen & Bewusstsein", t: "Verständnis schafft Veränderung. Wir vermitteln Wissen, das dich stärkt." },
      { h: "Achtsamkeit & Selbstfürsorge", t: "Achtsamkeitsübungen und Rituale für mehr Balance, Klarheit und innere Ruhe." },
      { h: "Systemische Perspektive", t: "Wir betrachten dich im Kontext deiner Familie, deiner Geschichte und deines Umfelds." },
      { h: "Praxisnahe Werkzeuge", t: "Konkrete Tools und Methoden für deinen Alltag — einfach umsetzbar." },
      { h: "Community & Verbundenheit", t: "Gemeinsam statt allein. Austausch, Unterstützung und echte Verbindung." },
    ],
    mantra:
      "Wir arbeiten nicht an dir. Wir gehen den Weg mit dir — in deinem Tempo, in deinem Rhythmus, in deiner Kraft.",
    side: {
      title: "Was uns besonders macht",
      items: [
        "Tiefe Erfahrung und praktische Expertise.",
        "Ganzheitlicher Ansatz für Körper, Geist & Seele.",
        "Individuelle Begleitung statt Standardlösungen.",
        "Sichere Räume für Wachstum und Heilung.",
        "Herzorientierte Community.",
        "Nachhaltige Transformation statt schneller Fixes.",
      ],
    },
    cta: {
      title: "Unsere Methoden sind Wege zurück zu dir",
      sub: "Zurück zu deiner Kraft. Zurück zu dem, was wirklich zählt.",
    },
    footerStrip: [
      { h: "Liebe", t: "" },
      { h: "Achtsamkeit", t: "" },
      { h: "Respekt", t: "" },
      { h: "Authentizität", t: "" },
      { h: "Verantwortung", t: "" },
      { h: "Exzellenz", t: "" },
    ],
    footerStripTitle: "Unsere Werte in der Anwendung",
    footerStripClosing:
      "Diese Werte leben wir — in jeder Methode, in jedem Kontakt, in jeder Begegnung.",
  },

  // ── 8 · FÜR WEN IST MUTTERSTIMME? ──────────────────────────────────────
  {
    num: 8,
    type: "content",
    layout: "grid",
    kicker: "FÜR WEN IST MUTTERSTIMME™?",
    title: "Für jede Mutter. In jeder Lebensphase.",
    subtitle:
      "Egal, ob du gerade erst Mama wirst, mittendrin steckst oder deine Kinder schon erwachsen sind — du bist hier genau richtig.",
    intro: "Du bist nicht allein. Du bist willkommen. Du bist wichtig.",
    bullets: [
      { h: "Werdende Mutter", t: "Du möchtest dich bewusst auf die Mutterschaft vorbereiten und innerlich stärken." },
      { h: "Mama im Alltag", t: "Du jonglierst Familie, Job und Alltag — und suchst nach mehr Balance und Kraft." },
      { h: "Mehrfachmutter", t: "Du gibst jeden Tag dein Bestes und möchtest dich selbst dabei nicht verlieren." },
      { h: "Alleinerziehende", t: "Du trägst viele Verantwortungen — und wünschst dir Unterstützung und Halt." },
      { h: "Mutter von großen Kindern", t: "Du möchtest deine Beziehung neu gestalten und loslassen lernen." },
      { h: "Jede Mutter, überall", t: "Egal wo du stehst — dein Weg zählt. Deine Transformation beginnt jetzt." },
    ],
    mantra:
      "Es gibt nicht die perfekte Mutter. Es gibt nur dich — und das ist mehr als genug.",
    side: {
      title: "Du bist hier richtig, wenn du",
      items: [
        "Dir mehr Zeit für dich wünschst.",
        "Dich oft erschöpft und überfordert fühlst.",
        "Innere Balance und Leichtigkeit suchst.",
        "Bessere Grenzen setzen möchtest.",
        "Deine Beziehung zu deinen Kindern stärken willst.",
        "Dich nach Austausch mit anderen Müttern sehnst.",
        "Persönlich wachsen und heilen möchtest.",
      ],
    },
    cta: {
      title: "Jede Mutter · Jede Geschichte · Jeder Weg",
      sub: "Wir ehren dich und deinen Weg. Gemeinsam wachsen wir — für uns. Für unsere Kinder. Für die Welt.",
    },
    badge: {
      title: "Dein Weg · In deinem Tempo",
      lines: [
        "Wertfrei und achtsam.",
        "Flexibel und alltagsnah.",
        "Vertraulich und sicher.",
        "Mit Herz und Kompetenz an deiner Seite.",
      ],
    },
  },

  // ── 9 · DEIN ERBE ALS MUTTER ───────────────────────────────────────────
  {
    num: 9,
    type: "content",
    layout: "grid",
    kicker: "DEIN ERBE ALS MUTTER",
    title: "Du prägst Leben. Heute. Morgen. Für immer.",
    subtitle:
      "Deine Kinder werden sich nicht an perfekte Mahlzeiten, makellose Häuser oder teure Ausflüge erinnern.",
    intro:
      "Sie werden sich erinnern, wie sie sich bei dir gefühlt haben. Deine Liebe. Deine Präsenz. Deine Worte. Dein Blick. Dein Herz.",
    bullets: [
      { h: "Emotionale Sicherheit", t: "Du schenkst deinen Kindern das Gefühl: „Ich bin geliebt — so wie ich bin.“" },
      { h: "Werte & Haltung", t: "Du lebst Werte vor, die zu ihrem inneren Kompass werden." },
      { h: "Selbstvertrauen", t: "Du stärkst ihr Vertrauen in sich selbst, ihre Fähigkeiten und ihren eigenen Weg." },
      { h: "Beziehungsfähigkeit", t: "Du zeigst ihnen, was echte Liebe, Respekt und gesunde Grenzen bedeuten." },
      { h: "Lebenserbe", t: "Du hinterlässt Spuren in ihren Herzen, die sie ein Leben lang begleiten." },
    ],
    mantra:
      "Was du heute in dein Kind hinein säst, wird morgen in der Welt aufblühen.",
    side: {
      title: "Was deine Kinder brauchen",
      items: [
        "Deine ungeteilte Aufmerksamkeit.",
        "Deine liebevolle Führung.",
        "Deinen Glauben an sie.",
        "Deine ehrliche Kommunikation.",
        "Dein Vorbild im Umgang mit dir selbst.",
        "Dein „Ich bin für dich da“ — immer wieder.",
        "Deine Balance, damit sie lernen, wie es geht.",
      ],
    },
    cta: {
      title: "Du bist nicht nur Mutter",
      sub: "Du bist ihre erste Lehrerin. Ihre sichere Heimat. Ihr Für-immer.",
    },
    badge: {
      title: "Dein Erbe wirkt weiter",
      lines: [
        "Was du heute lebst und gibst, wird in deinem Kind weiterleben — und durch dein Kind in der nächsten Generation.",
        "Du bist der Anfang einer Welle, die Generationen verändert.",
        "Dein Herz ist der Ursprung. Deine Liebe ist die Kraft.",
      ],
    },
  },

  // ── 10 · DIE ZUKUNFT BEGINNT MIT DIR — HEUTE ───────────────────────────
  {
    num: 10,
    type: "content",
    layout: "grid",
    kicker: "DIE ZUKUNFT BEGINNT MIT DIR — HEUTE",
    title: "Kleine Schritte. Große Wirkung. Eine erfüllte Mutterschaft.",
    subtitle:
      "Du musst nicht alles sofort verändern. Aber du kannst heute beginnen. Für dich. Für deine Kinder. Für die Frauen, die nach dir kommen.",
    intro:
      "Jede bewusste Entscheidung ist ein Geschenk — an dich selbst und an die nächste Generation.",
    bullets: [
      { h: "Reflektiere", t: "Nimm dir 10 Minuten für dich. Was tut dir gut? Was brauchst du wirklich?" },
      { h: "Sei liebevoll zu dir", t: "Sprich mit dir so, wie du mit deiner besten Freundin sprechen würdest." },
      { h: "Plane deine Auszeiten", t: "Blockiere bewusste Zeit nur für dich — und halte sie dir heilig." },
      { h: "Verbinde dich", t: "Tausche dich mit anderen Müttern aus. Gemeinsam geht es leichter." },
      { h: "Lernen & Wachsen", t: "Investiere in Wissen, das dich stärkt und deine Familie bereichert." },
      { h: "Handle mit Herz", t: "Triff Entscheidungen aus deinem Herzen — nicht aus Pflicht oder Druck." },
    ],
    mantra:
      "Die Zukunft gehört nicht nur denen, die auf sie warten. Die Zukunft gehört denen, die sie gestalten — mit Liebe, Mut und Bewusstsein.",
    side: {
      title: "Dein Versprechen an dich",
      items: [
        "Ich wähle mich — jeden Tag ein Stück mehr.",
        "Ich ehre meine Bedürfnisse.",
        "Ich schaffe Balance, nicht Perfektion.",
        "Ich schenke meinen Kindern eine starke, glückliche Mutter.",
        "Ich lebe mein Erbe — bewusst und voller Liebe.",
        "Ich bin die Veränderung, die ich mir für die Welt wünsche.",
      ],
    },
    cta: {
      title: "Wir verändern die Welt — eine Mutter nach der anderen",
      sub: "Indem du dich veränderst, veränderst du deine Familie. Indem du deine Familie veränderst, veränderst du die Welt. Deine Reise. Dein Erbe. Deine Wirkung.",
    },
    badge: {
      title: "Was du mit der SAT Akademie gewinnst",
      lines: [
        "Fundiertes Wissen, das dich weiterbringt.",
        "Praxisnahe Methoden für deinen Alltag.",
        "Eine inspirierende Community an deiner Seite.",
        "Persönliche Begleitung auf deiner Reise.",
        "Nachhaltige Transformation für dich und deine Familie.",
      ],
    },
    closing: "Deine Reise beginnt jetzt. Wir sind für dich da.",
  },
  // ── 11 · WAS DU NACH DER MUTTERSTIMME ERLEBST ──────────────────────────
  {
    num: 11,
    type: "content",
    layout: "grid",
    kicker: "DEIN WEG · DEIN ERBE · EINE BESSERE ZUKUNFT",
    title: "Du bist die Veränderung. Deine Mutterstimme™ ist der Anfang.",
    subtitle:
      "Du kannst nicht alles verändern. Aber du kannst den ersten Schritt gehen. Und genau dieser Schritt verändert alles — für dich, deine Kinder und die Welt.",
    intro:
      "Sei die Mutter, die du dir als Kind gewünscht hättest. Sei die Frau, die ihre Stimme nutzt. Sei die Veränderung.",
    bullets: [
      { h: "Mehr Selbstliebe", t: "Du fühlst dich wertvoll, stark und verbunden mit dir selbst." },
      { h: "Innere Balance", t: "Du gehst gelassener durch den Alltag und triffst klare Entscheidungen." },
      { h: "Stärkere Beziehungen", t: "Du schaffst echte Verbindung und Vertrauen in deiner Familie." },
      { h: "Persönliches Wachstum", t: "Du entwickelst dich weiter — in deinem Tempo und mit Freude." },
      { h: "Nachhaltige Wirkung", t: "Dein Erbe lebt weiter — in deinen Kindern, deiner Familie und in der Welt." },
      { h: "Deine Kraft erblüht", t: "Du wirst zur Quelle von Liebe, Stabilität und Inspiration für kommende Generationen." },
    ],
    mantra:
      "Deine Liebe heute ist die Sicherheit von morgen. Deine Worte heute sind das Fundament von übermorgen. Dein Erbe verändert die Welt.",
    side: {
      title: "Das erwartet dich im Programm",
      items: [
        "Fundiertes Wissen & tiefgehende Methoden.",
        "Praxisnahe Übungen für deinen Alltag.",
        "Begleitung von Herz zu Herz.",
        "Austausch in einer wertschätzenden Community.",
        "Impulse, die dich nachhaltig transformieren.",
        "Flexibel, online oder vor Ort.",
        "Für Mütter in jeder Lebensphase.",
        "Für eine bessere Zukunft — gemeinsam.",
      ],
    },
    cta: {
      title: "Dein Weg beginnt mit einem Schritt",
      sub: "Du musst ihn nicht allein gehen. Wir sind an deiner Seite — mit Herz, Erfahrung und einem gemeinsamen Ziel: Mütter stärken. Familien heilen. Die Welt verändern.",
    },
    closing: "Du bist nicht nur eine Mutter. Du bist eine Visionärin. Du bist eine Heilerin. Du bist Zukunft.",
  },

  // ── 12 · DIE KRAFT DER WEIBLICHEN INTUITION ────────────────────────────
  {
    num: 12,
    type: "content",
    layout: "grid",
    kicker: "DIE KRAFT DER WEIBLICHEN INTUITION",
    title: "Dein inneres Wissen ist ein Geschenk.",
    subtitle:
      "Als Mutter trägst du eine besondere Weisheit in dir. Deine Intuition ist wie ein innerer Kompass, der dich und deine Kinder sicher führt.",
    intro:
      "Sie ist leise, aber mächtig. Sie spricht aus deinem Herzen. Vertraue dir. Deine Intuition weiß den Weg.",
    bullets: [
      { h: "Bauchgefühl", t: "Dein Bauch weiß oft früher, was richtig ist, als dein Verstand. Lerne, die leisen Signale deines Körpers wahrzunehmen." },
      { h: "Vertrauen", t: "Vertraue dem Leben. Vertraue dir selbst. Vertraue deiner Führung. Vertrauen ist die Basis für inneren Frieden." },
      { h: "Herzweisheit", t: "Dein Herz erkennt, was Liebe braucht — für dich und deine Kinder. Dein Herz kennt die Wahrheit." },
      { h: "Innere Führung", t: "Du bist geführt. Auch wenn der Weg nicht immer klar ist. Deine Intuition zeigt dir den nächsten richtigen Schritt." },
    ],
    mantra:
      "Deine Intuition ist deine Verbindung zu deiner Seele. Je mehr du ihr vertraust, desto leichter wird dein Weg.",
    side: {
      title: "So stärkst du deine Intuition",
      items: [
        "Nimm dir täglich Zeit für Stille.",
        "Höre auf deine innere Stimme.",
        "Schreibe deine Eingebungen auf.",
        "Vertraue den Zeichen und Synchronizitäten.",
        "Verbringe Zeit in der Natur.",
        "Handle aus dem Herzen, nicht aus der Angst.",
      ],
    },
    cta: {
      title: "Deine Intuition ist die Brücke zwischen Himmel und Erde",
      sub: "Sie verbindet dich mit deiner inneren Weisheit, mit deinen Ahnen und mit der Liebe, die größer ist als du. Sie zeigt dir deinen Weg. Jeden Tag. Schritt für Schritt.",
    },
    footerStrip: [
      { h: "Mehr Klarheit", t: "" },
      { h: "Sichere Entscheidungen", t: "" },
      { h: "Inneren Frieden", t: "" },
      { h: "Tiefe Verbindung zu deinen Kindern", t: "" },
      { h: "Leben in deiner Wahrheit", t: "" },
    ],
    footerStripTitle: "Das bringt dir eine starke Intuition",
    footerStripClosing: "Vertraue dir. Deine Intuition ist dein größtes Geschenk.",
  },

  // ── 13 · SELBSTFÜRSORGE IST KEIN LUXUS ─────────────────────────────────
  {
    num: 13,
    type: "content",
    layout: "grid",
    kicker: "SELBSTFÜRSORGE IST KEIN LUXUS",
    title: "Sie ist deine Grundbasis.",
    subtitle: "Nur wenn es dir gut geht, kannst du für andere da sein.",
    intro:
      "Du darfst gut für dich sorgen. Du darfst auftanken. Selbstfürsorge ist Selbstachtung. Und ein Geschenk an deine Kinder.",
    bullets: [
      { h: "Energiehaushalt", t: "Achte auf deine Energie. Was gibt dir Kraft? Was raubt sie dir?" },
      { h: "Grenzen", t: "Gesunde Grenzen sind kein Egoismus — sie sind Selbstrespekt." },
      { h: "Auftanken", t: "Plane bewusst Zeit nur für dich ein. Regelmäßig und ohne schlechtes Gewissen." },
      { h: "Schuldgefühle loslassen", t: "Du musst nicht perfekt sein. Du darfst gut genug sein. Das ist genug." },
      { h: "Selbstliebe", t: "Sei deine beste Freundin. Sprich liebevoll mit dir. Du bist wichtig." },
    ],
    mantra:
      "Wenn du für dich sorgst, leuchtest du von innen heraus — und deine Kinder spüren es jeden Tag.",
    side: {
      title: "Selbstfürsorge-Ideen für dich",
      items: [
        "Morgens 10 Minuten nur für dich.",
        "Spaziergänge in der Natur.",
        "Nährende Ernährung.",
        "Tagebuch schreiben.",
        "Kreativität & Hobbys.",
        "Deine Lieblingsmusik hören und tanzen.",
        "Bewusst Nein sagen.",
        "Unterstützung annehmen.",
      ],
    },
    cta: {
      title: "Wenn du dich selbst liebevoll umarmst",
      sub: "Lehrst du deine Kinder, wie sich Selbstliebe anfühlt. Du bist wichtig. Du darfst strahlen. Du bist es wert. Du kannst nur weitergeben, was in dir selbst lebendig ist.",
    },
    badge: {
      title: "Gute Mütter passieren nicht",
      lines: [
        "Sie entstehen aus Selbstfürsorge, Selbstliebe und bewussten Entscheidungen.",
        "Du bist der Mittelpunkt deines Lebens. Und das ist gut so.",
      ],
    },
    closing:
      "Du hast die Erlaubnis, dich an die erste Stelle zu setzen. Das macht dich nicht egoistisch, sondern liebevoll.",
  },

  // ── 14 · VON GENERATION ZU GENERATION · FINALE ─────────────────────────
  {
    num: 14,
    type: "content",
    layout: "grid",
    kicker: "VON GENERATION ZU GENERATION",
    title: "Dein Erbe wirkt weiter.",
    subtitle:
      "Du bist Teil einer Linie von Frauen. Du bist Vorbild. Heilerin. Wegbereiterin.",
    intro: "Heile, was dich belastet. Gib weiter, was dich stärkt.",
    bullets: [
      { h: "Ahnenlinie", t: "Du bist verbunden mit allen Frauen vor dir. Ehre ihre Kraft. Heile ihre Wunden." },
      { h: "Vorbildfunktion", t: "Deine Kinder lernen von dir — in jedem Moment. Sei das Vorbild, das du selbst gebraucht hättest." },
      { h: "Heilung", t: "Heilung passiert durch Bewusstsein, Vergebung und Liebe. Du darfst heilen." },
      { h: "Werte weitergeben", t: "Deine Werte sind Geschenke. Gib sie weiter — mit Worten und Taten. Sie darf ein Schatz sein." },
      { h: "Zukunft gestalten", t: "Du gestaltest nicht nur dein Leben — du gestaltest die Zukunft deiner Kinder und Enkelkinder." },
    ],
    secondary: {
      title: "MUTTERSTIMME™ Bewegung",
      steps: [
        { h: "Community", t: "Wir sind mehr als ein Programm. Wir sind eine Gemeinschaft von Müttern, die sich gegenseitig stärken." },
        { h: "Vision", t: "Eine Welt, in der Mütter in ihrer Wahrheit leben. Kinder in Liebe aufwachsen. Familien bewusst und verbunden sind." },
        { h: "Mitmachen", t: "Werde Teil der Mutterstimme-Bewegung. Teile deine Stimme. Sei ein Licht für andere. Gemeinsam sind wir stark." },
        { h: "Wirkung", t: "Eine bewusste Mutter verändert nicht nur ihr eigenes Leben — sie verändert die Welt." },
      ],
    },
    mantra:
      "Was du heute lebst, prägt, was deine Kinder morgen leben. Sei die Veränderung. Sei die Heilung. Sei die Liebe.",
    side: {
      title: "Fragen zur Reflexion",
      items: [
        "Welche Muster möchte ich heilen und loslassen?",
        "Welche Werte möchte ich weitergeben?",
        "Welche Frau möchte ich für meine Kinder sein?",
        "Was ist mein größter Wunsch für die nächste Generation?",
        "Wie kann ich heute schon ein Vorbild sein?",
      ],
    },
    cta: {
      title: "Du bist wichtig. Du bist genug. Du bist Liebe.",
      sub: "Deine Stimme zählt. Deine Intuition führt. Deine Liebe heilt. Deine Präsenz verändert. Danke, dass du den Mut hast, deine Mutterstimme zu leben. Wir gehen diesen Weg gemeinsam.",
    },
    closing:
      "Erhebe deine Stimme. Vertraue deiner Intuition. Lebe deine Wahrheit. Für dich. Für deine Kinder. Für die Welt.",
  },

  // ── 15 · FINALE · MUTTERSTIMME™ BEWEGUNG ───────────────────────────────
  {
    num: 15,
    type: "content",
    layout: "grid",
    kicker: "MUTTERSTIMME™ BEWEGUNG",
    title: "Gemeinsam für bewusste Mütter. Für starke Familien. Für eine bessere Welt.",
    subtitle:
      "Mutterstimme™ ist mehr als ein Angebot — es ist eine Bewegung. Eine Bewegung von Müttern, die bereit sind, hinzuschauen, zu heilen, zu wachsen und ihre Kinder bewusst in eine neue Zeit zu führen.",
    intro:
      "Deine Stimme zählt. Deine Erfahrung ist wertvoll. Dein Weg inspiriert. Deine Liebe verändert.",
    bullets: [
      { h: "Community", t: "Eine wachsende Gemeinschaft von Frauen, die sich gegenseitig stützen, inspirieren und begleiten. Wir sind nicht perfekt, aber wir gehen gemeinsam." },
      { h: "Vision", t: "Eine Welt, in der jede Mutter gehört wird. Eine Welt, in der Kinder in Liebe, Respekt und Freiheit aufwachsen können. Eine Welt, die von Herzen geführt wird." },
      { h: "Mitmachen", t: "Ob im Coaching, in Workshops, in der Community oder durch das Teilen deiner Geschichte — jeder Beitrag zählt. Sei Teil der Veränderung." },
      { h: "Wirkung", t: "Bewusste Mütter bewirken bewusste Kinder. Bewusste Familien schaffen eine bewusste Zukunft für alle." },
    ],
    mantra: "Wenn viele Mütter ihre Stimme erheben, verändert sich die Welt.",
    side: {
      title: "Unsere gemeinsame Vision",
      items: [
        "Wir ehren die Mutter in all ihren Facetten.",
        "Wir stärken das Vertrauen in unsere Intuition.",
        "Wir begleiten unsere Kinder mit Liebe und Klarheit.",
        "Wir schaffen Räume für Heilung und Wachstum.",
        "Wir verbinden Herz, Verstand und Seele.",
        "Wir gestalten eine Welt, die von Liebe geführt wird.",
      ],
    },
    secondary: {
      title: "Deine Reise geht weiter — wir gehen sie gemeinsam",
      steps: [
        { h: "Workshops & Events", t: "" },
        { h: "Coachings & Begleitung", t: "" },
        { h: "Online-Kurse & Ressourcen", t: "" },
        { h: "Austausch & Community", t: "" },
        { h: "Inspiration & Impulse", t: "" },
      ],
    },
    cta: {
      title: "Du bist nicht allein. Wir sind viele.",
      sub: "Für unsere Kinder. Für uns selbst. Für eine neue Zeit.",
    },
    badge: {
      title: "Gratulation — du hast alle 15 Folien abgeschlossen",
      lines: [
        "Danke, dass du dein Herz öffnest.",
        "Danke, dass du für dich und deine Kinder den Mut hast.",
        "Du bist die Veränderung. Du bist Mutterstimme.",
        "Wir freuen uns auf dich.",
      ],
    },
    closing:
      "Deine Reise beginnt jetzt — und sie geht weiter, jeden Tag neu.",
  },
];

export default mutterstimmeSlides;
